















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Form, FormElement } from '../models/Form';
import { BAlert } from 'bootstrap-vue';

@Component({
    name: 'ElementBase',
    components: {
        'b-alert': BAlert,
    },
    computed: {
        ...mapGetters(['errors', 'form', 'elements', 'current']),
    },
})
export default class ElementBase extends Vue {
    elements!: FormElement[];

    @Prop() element!: FormElement;

    onDismissed(error: string) {
        this.$store.commit('removeError', error);
    }

    prev() {
        this.$store.commit('clearErrors');
        this.$store.commit('setLoading', true);
        setTimeout(async () => {
            this.$store.commit('prev', this.element);
            this.$emit('prev');
            this.$store.commit('setLoading', false);
        }, 400);
    }
}
